// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDG0oUc1UwrWRdXQZ1v-qOhutgIj9Aod1U",
  authDomain: "imagetohtmlcssaiproject09.firebaseapp.com",
  projectId: "imagetohtmlcssaiproject09",
  storageBucket: "imagetohtmlcssaiproject09.firebasestorage.app",
  messagingSenderId: "1094171380902",
  appId: "1:1094171380902:web:2f8ffaf5a7eb066299b867",
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export default auth;
